import angular from 'angular';
import swoaPropertiesService from './properties.service';

export default angular.module('swoa.property', [swoaPropertiesService]).name;
